export default __webpack_public_path__ + "static/media/Iconly-Bold-Notification.662466ac.svg";